import {
  Popover,
  Transition,
  PopoverButton,
  PopoverPanel,
} from "@headlessui/react";
import {
  Bars3Icon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { Fragment, useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import DarkModeToggle from "./individuals/DarkModeToggle";
import { paths } from "../globals";
import Dropdown from "./individuals/dropdown";

export default function Header() {
  const location = useLocation();
  const isActive = (href) =>
    location.hash === href ||
    (location.pathname.includes("/articles/") && href === "/articles") ||
    ((location.hash === "#home" || location.hash === "") &&
    href === "/#home" &&
    location.pathname === "/"
      ? true
      : false) ||
    location.pathname === href;

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100); // Trigger sticky after 100px
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header
      className={
        "top-0 z-50 w-screen transition-all duration-300 font-navbar fixed " +
        (isSticky
          ? "dark:bg-[#090f1b]/60 bg-white/60 backdrop-blur"
          : "bg-transparent")
      }
    >
      <div className="flex flex-wrap lg:flex-nowrap items-center justify-between px-5 lg:px-10 2xl:px-20 py-4">
        {/* Logo */}
        <div className="max-w-[250px] xl:max-w-[350px] min-h-[50px] min-w-[46px]">
          <a href="/" className="inline-block">
            <img
              src="/assets/logo.png"
              alt="logo"
              className="hidden dark:block h-[50px]"
            />
            <img
              src="/assets/logo.png"
              alt="logo"
              className="block dark:hidden h-[50px]"
            />
          </a>
        </div>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center justify-between flex-1">
          <nav className="ml-10">
            <ul className="flex space-x-10 text-base font-main">
              {paths.map((item, index) => (
                <li key={index}>
                  <a
                    href={item.path}
                    className={
                      "text-dark-text hover:text-primary dark:hover:text-white cursor-pointer " +
                      (isActive(item.path) ? "text-primary" : "")
                    }
                  >
                    {item.name}
                  </a>
                </li>
              ))}

            </ul>
          </nav>

          {/* Buttons */}
          <div className="flex space-x-4 items-center justify-center align-middle">
            {/* <a
              href="signin.html"
              className="bg-primary text-white px-6 py-3 rounded-sm hover:bg-primary/90 cursor-pointer"
            >
              Sign In
            </a>
            <a
              href="signup.html"
              className="bg-[#222C40] text-white px-6 py-3 rounded-sm hover:bg-[#222C40]/90 cursor-pointer"
            >
              Sign Up
            </a> */}
            <Dropdown />
            <DarkModeToggle />
          </div>
        </div>

        {/* Mobile Menu Toggle */}
        <Popover className="lg:hidden">
          {({ open }) => (
            <>
              <DarkModeToggle className="lg:hidden mr-2" size="w-6 h-6" />
              <PopoverButton className="inline-flex rounded items-center justify-center p-2 text-gray-700 dark:text-white focus:outline-none hover:bg-gray-200 dark:hover:bg-gray-700">
                {open ? (
                  <XMarkIcon className="h-6 w-6 " />
                ) : (
                  <Bars3Icon className="h-6 w-6 " />
                )}
              </PopoverButton>

              <Transition
                as={Fragment}
                enter="transition ease-out duration-200"
                enterFrom="opacity-0 -translate-y-2"
                enterTo="opacity-100 translate-y-0"
                leave="transition ease-in duration-150"
                leaveFrom="opacity-100 translate-y-0"
                leaveTo="opacity-0 -translate-y-2"
              >
                <PopoverPanel className="absolute top-full left-0 w-full bg-white dark:bg-[#272d3a] z-40 p-5 space-y-4 shadow-lg">
                  {paths.map((item, index) => (
                    <a
                      href={item.path}
                      className={
                        "text-dark-text hover:text-primary dark:hover:text-white cursor-pointer block " +
                        (isActive(item.path) ? "text-primary" : "")
                      }
                    >
                      {item.name}
                    </a>
                  ))}
                  <a
                    key="STEMEPA"
                    href={"https://stemepa.com"}
                    className="text-dark-text hover:text-primary dark:hover:text-white cursor-pointer block"
                  >
                    {"Switch to STEM Pennsylvania"}
                  </a>
                </PopoverPanel>
              </Transition>
            </>
          )}
        </Popover>
      </div>
    </header>
  );
}
